import React from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";
import { BsExclamationCircle } from "react-icons/bs";
import { Spinner } from "../../elements";
import DataMessage from "../../data-message/components/data-message";

const propTypes = {
  isFetching: PropTypes.bool.isRequired,
  hasData: PropTypes.bool.isRequired,
  noDataMsg: PropTypes.string,
  hasError: PropTypes.bool.isRequired,
  errorMsg: PropTypes.string,
  children: PropTypes.node,
  clientLogo: PropTypes.string
};

const defaultProps = {
  errorMsg: "",
  clientLogo: "",
  children: null,
  noDataMsg: ""
};

function Loading(props) {
  const {
    isFetching,
    hasData,
    hasError,
    errorMsg,
    noDataMsg,
    children,
    clientLogo
  } = props;

  if (hasError) {
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100">
        <Alert color="danger">
          <BsExclamationCircle size="2em" />
          <span className="ml-2">{errorMsg}</span>
        </Alert>
      </div>
    );
  }

  if (!isFetching && hasData) {
    return <>{children}</>;
  }

  return (
    <div className="d-flex justify-content-center align-items-center w-100 h-100 position-relative">
      {isFetching && <Spinner />}
      {!isFetching && !hasData && (
        <DataMessage dataMsg={noDataMsg} clientLogo={clientLogo} />
      )}
    </div>
  );
}

Loading.propTypes = propTypes;
Loading.defaultProps = defaultProps;

export default Loading;
